import React from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { EnTetePage } from "../components/EnTetePage";
import { CarteFormation } from "../components/CarteFormation";
import { CallToAction } from "../components/CallToAction";
import { PageIntrouvable } from "./PageIntrouvable";
import { formations, formationParSlug } from "../data/mockData";

const INSCRIPTION = "/?sujet=formation#contact";

export const FormationPage = () => {
  const { slug } = useParams();
  const formation = formationParSlug(slug);
  if (!formation) return <PageIntrouvable />;

  const autres = formations.filter((f) => f.slug !== slug).slice(0, 3);
  const fiche = [
    ["Niveau", formation.level],
    ["Durée", formation.duration],
    ["Format", formation.format],
    ["Participants", `${formation.maxParticipants} au maximum`],
  ];

  return (
    <>
      <EnTetePage
        chemin={[
          ["Accueil", "/"],
          ["Formations", "/formations"],
        ]}
        titre={formation.title}
        chapo={formation.description}
      >
        <Link to={INSCRIPTION} className="btn-accent">
          S'inscrire
          <ArrowRight className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" />
        </Link>
        <Link to="/formations" className="btn-outline">
          Toutes les formations
        </Link>
      </EnTetePage>

      <section className="section">
        <div className="shell grid gap-8 lg:grid-cols-3 lg:gap-12">
          <div className="space-y-10 lg:col-span-2">
            <div>
              <h2 className="h2">Pour qui</h2>
              <p className="mt-5 text-vt-chapo leading-relaxed text-t2">{formation.public}</p>
            </div>

            <div>
              <h2 className="h2">Objectif</h2>
              <p className="mt-5 text-vt-chapo leading-relaxed text-t2">{formation.objectif}</p>
            </div>

            <div>
              <h2 className="h2">Programme</h2>
              <ol className="mt-6 grid gap-3 sm:grid-cols-2">
                {formation.topics.map((topic) => (
                  <li
                    key={topic}
                    className="flex items-start gap-2.5 rounded-[12px] border border-border bg-white p-4 font-semibold"
                  >
                    <Check
                      className="mt-1 h-4 w-4 flex-none text-accent"
                      strokeWidth={2.6}
                      aria-hidden="true"
                    />
                    {topic}
                  </li>
                ))}
              </ol>
            </div>

            <div>
              <h2 className="h2">Prérequis</h2>
              <ul className="mt-6 grid gap-3">
                {formation.prerequisites.map((prerequis) => (
                  <li key={prerequis} className="flex items-start gap-2.5 font-semibold">
                    <Check
                      className="mt-1 h-4 w-4 flex-none text-accent"
                      strokeWidth={2.6}
                      aria-hidden="true"
                    />
                    {prerequis}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <aside aria-labelledby="fiche-formation" className="lg:col-span-1">
            <div className="rounded-[20px] border border-border bg-white p-8 lg:sticky lg:top-28">
              <h2 id="fiche-formation" className="text-vt-h3 font-extrabold text-brand">
                En bref
              </h2>
              <dl className="mt-6 divide-y divide-border">
                {fiche.map(([libelle, valeur]) => (
                  <div key={libelle} className="flex flex-wrap justify-between gap-x-4 gap-y-1 py-3">
                    <dt className="font-semibold text-t2">{libelle}</dt>
                    <dd className="font-bold text-brand">{valeur}</dd>
                  </div>
                ))}
              </dl>
              <p className="mt-6 text-vt-controle leading-relaxed text-t2">
                Sessions en présentiel à Gatineau ou à distance. Dates et
                tarif communiqués sur demande.
              </p>
              <Link to={INSCRIPTION} className="btn-accent mt-6 w-full">
                S'inscrire
                <ArrowRight className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" />
              </Link>
            </div>
          </aside>
        </div>
      </section>

      <section className="section section-alt">
        <div className="shell">
          <h2 className="h2">Autres formations</h2>
          <div className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {autres.map((autre) => (
              <CarteFormation key={autre.slug} formation={autre} detaillee={false} />
            ))}
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
};
